import { useCallback } from 'react'
import { GrcExportPromiseClient } from '@trustero/trustero-api-web/lib/grcexport/grcexport_grpc_web_pb'
import {
  UploadFileRequest,
  UploadFileResponse,
} from '@trustero/trustero-api-web/lib/grcexport/grcexport_pb'
import { useAuthorizedGrpcClient } from 'src/adapter/grpcClient'

export type ReceptorFileUploadTarget = {
  receptorId: string
  uploadTargetKey?: string
  recordFields?: Record<string, string>
}

export const isOnspringUploadTargetKey = (value?: string): boolean =>
  /^onspring-[^-]+(?:-[^-]+)?-field-[^-]+$/.test((value || '').trim())

export const useUploadReceptorFile = (): ((payload: {
  receptorId: string
  contentId?: string
  uploadTargetKey?: string
  recordFields?: Record<string, string>
  body?: Uint8Array
  fileName?: string
  mimeType?: string
}) => Promise<UploadFileResponse>) => {
  const client = useAuthorizedGrpcClient(GrcExportPromiseClient)

  return useCallback(
    async ({
      receptorId,
      contentId,
      uploadTargetKey,
      recordFields,
      body,
      fileName,
      mimeType,
    }) => {
      const request = new UploadFileRequest()
      request.setReceptorId(receptorId)
      if (contentId) {
        request.setContentId(contentId)
      }
      if (uploadTargetKey) {
        request.setUploadTargetKey(uploadTargetKey)
      }
      Object.entries(recordFields || {}).forEach(([fieldId, value]) => {
        request.getRecordFieldsMap().set(fieldId, value)
      })
      if (body) {
        request.setBody(body)
      }
      if (fileName) {
        request.setFileName(fileName)
      }
      if (mimeType) {
        request.setMimeType(mimeType)
      }
      return await client.uploadFile(request)
    },
    [client],
  )
}
